<template>
  <div class="login-container">
    <div class="loginbox">
      <div class="title">法务二司系统</div>
      <div>
        <el-input class="ip1" placeholder="请输入账号" prefix-icon="el-icon-user-solid" v-model="input2" clearable>
        </el-input>
      </div>
      <div>
        <form>
          <el-input @keyup.enter.native="login" class="ip2" placeholder="请输入密码" prefix-icon="el-icon-lock"
            v-model="input" show-password clearable>
          </el-input>
        </form>
      </div>
      <slide-verify style="margin-top: 20px" :l="42" :r="10" :w="300" :h="80" :imgs="imgs" slider-text="向右滑动"
        @success="onSuccess" @fail="onFail" @refresh="onRefresh"></slide-verify>
      <div :style="msg == '验证成功！' ? 'color:#2bdc70' : 'color:#e64a19'">
        {{ msg }}
      </div>
      <el-button class="btn" @click="login">登录</el-button>
    </div>
  </div>
</template>

<script>
import { loginAdmin, getRemind } from '@/api/login/login.js'
import { mapMutations } from 'vuex';
import WebIM from "@/utils/initWeb";
import {
  setUid,
  setEasemobName,
  setEasemobPwd,
  setServiceID
} from '@/utils/auth'
export default {
  beforeCreate: function () {
    document.getElementsByTagName("body")[0].className = "body-bg";
  },
  data() {
    return {
      msg: "",
      verify: 2, // 1验证成功  2验证失败
      imgs: [
        "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Flmg.jj20.com%2Fup%2Fallimg%2F1114%2F0406210Z024%2F2104060Z024-11-1200.jpg&refer=http%3A%2F%2Flmg.jj20.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1668050452&t=a8eeec2f6f7b4aff883b85ee2276ea4d",
        "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Flmg.jj20.com%2Fup%2Fallimg%2F1114%2F033021091503%2F210330091503-6-1200.jpg&refer=http%3A%2F%2Flmg.jj20.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1668050510&t=b07c3793fe21bd8cb17e2490a11b664d",
        "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Flmg.jj20.com%2Fup%2Fallimg%2F1114%2F041621122252%2F210416122252-1-1200.jpg&refer=http%3A%2F%2Flmg.jj20.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1668050503&t=63bbb5a9c3ac56b66f20240b63e98f34",
      ],
      src: "",
      input2: "", // 账号
      input: "", // 密码
      drawer: false, // 是否开启抽屉
      text: "向右拖动滑块填充拼图", //滑块底部文字
      // state: "", //验证状态 1成功 2失败
    };
  },
  methods: {
    ...mapMutations('role', ['changestate', 'changerealauth', 'changedefaultPatch', 'changenickname', 'changetoken', 'changebtnAuth']),
    onSuccess() {
      this.msg = "验证成功！";
      this.verify = 1;
      setTimeout(() => {
        this.onRefresh();
      }, 1000);
    },
    onFail() {
      this.msg = "验证失败，请重新验证！";
      this.verify = 2;
      setTimeout(() => {
        this.onRefresh();
      }, 1000);
    },
    onRefresh() {
      this.msg = "";
    },
    async login() {
      if (this.input2 == "") {
        this.$message_e('账号不能为空')
        return;
      } else if (this.input == "") {
        this.$message_e('密码不能为空')
        return;
      } else if (this.verify != 1) {
        this.$message_e('滑动验证错误')
        return;
      } else {
        await loginAdmin({
          username: this.input2,
          password: this.input,
        }).then(res => {
          if (res.code == 1) {
            console.log("🚀🚀🚀🚀🚀🚀", res);
            this.$message_c('登录成功')
            setUid(res.data.admin.id || '')
            // 环信相关
            setEasemobName(res.data.admin.easemob_name || '')
            setEasemobPwd(res.data.admin.easemob_pwd || '')

            // 客服当前角色客服id(客服接待使用)
            setServiceID(res.data.admin.service_id || 0)

            this.changestate(res.data.menu)
            // 处理生成角色实际拥有访问的path
            let pathArr = []
            res.data.menu.forEach(item => {
              pathArr.push(item.path)
              if (item.children.length > 0) {
                item.children.forEach(item2 => {
                  pathArr.push(item2.path)
                })
              }
            });
            const defaultPath = [
              '/welcome',
              '/introduceEdit',
              '/receptionRecord',
              '/workTickets',
              '/workTicketsAdd',
              '/serviceClassify',
              '/serviceGoodsAdd',
              '/contractGoodsAdd',
              '/documentClassify',
              '/serviceOrderDetail',
              '/serviceOrderChat',
              '/regulationsClassify',
              '/regulationsAdd',
            ]
            pathArr.push(defaultPath)
            this.changetoken(res.data.token)// 设置token
            this.changenickname(res.data.nickname) // 设置昵称
            this.changerealauth(pathArr) // 设置真实拥有权限
            // this.changedefaultPatch(res.data.menu[0].children[0].path) // 设置默认激活
            this.changebtnAuth(res.data.button) // 设置按钮权限
            sessionStorage.setItem('tabsList', JSON.stringify([{ name: '欢迎登录', path: '/welcome' }]))

            this.$router.push('/welcome')

            // 提醒客户跟进
            getRemind().then(res => {
              if (res.code == 1 && res.data.length > 0) {
                this.$notify({
                  title: '客户跟进提示',
                  message: `您有${res.data.length}个客户待跟进,点击前往跟进`,
                  duration: 0,
                  onClick: () => {
                    // 前往客户列表
                    this.$router.push({ name: 'ClientList' });
                    this.changedefaultPatch('/clientList')
                  },
                  onClose: (e) => {
                    console.log('我关闭了');
                  }
                });
              }
            })
          } else {
            this.$message_e(res.msg)
          }
        })
      }
    },
  },
  mounted() {
  },
}
</script>

<style lang="scss">
.body-bg {
  background-attachment: fixed;
  overflow: hidden;
}

.login-container {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  .loginbox {
    width: 300px;
    height: 344px;
    padding: 0 50px;
    padding-bottom: 70px;
    box-shadow: 0 1 1 1;
    background-color: #fff;
    box-shadow: -2px 3px 20px #ccc;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-left: 100px;
      margin-top: 20px;
    }

    .ip1 {
      width: 300px;
      margin: 20px 0;
    }

    .ip2 {
      width: 300px;
    }

    .code {
      width: 300px;
      height: 30px;
      font-size: 20px;
      display: flex;
      justify-content: flex-end;
      margin: 10px 0;

      .coder {
        height: 30px;
        width: 100px;
        text-align: center;
        background: linear-gradient(to right, #ff4e50, #f9d423);
        cursor: pointer;
      }
    }

    .verification {
      margin-top: 20px;
    }

    .btn {
      width: 300px;
      margin: 20px 0;
      color: #ffffff;
      background: #22a1ff;
    }

    .zubox {
      width: 400px;
      margin-top: 20px;

      .zhuce {
        cursor: pointer;
        margin-left: 250px;
      }
    }
  }

  .titles {
    display: flex;
    margin-top: 40px;
    margin-left: 20px;
    font-size: 20px;
    font-weight: bold;
  }
}
</style>
